export const institutos = {
  'undefined': '',
  '0': 'Itbm',
  '1': 'México',
  '2': 'Centro América y El Caribe',
  '3': 'China y Gran China',
  '4': 'Singapur',
  '5': 'Turquía',
  '6': 'Filipinas',
  '7': 'Ecuador',
  '8': 'izzi',
  '9': 'Rumania',
  '11': 'Brasil',
  '12': 'Chile',
  '13': 'Argentina',
  '14': 'Broker 14',
  '15': 'España',
  '16': 'Itbm',
  '17': 'One Survey',

}


export const sectores = {
   "1":{
      "NOMBRE":"2.0 Aeroespacial",
      "SUBSECTORES":{
         "1":"2.1 Aeroespacial // Otra / No aplica"
      }
   },
   "2":{
      "NOMBRE":"4.0 Agricultura",
      "SUBSECTORES":{
         "1":"4.1	Agricultura // Otra / No aplica"
      }
   },
   "3":{
      "NOMBRE":"5.0 Biotecnología y Farmacéutica",
      "SUBSECTORES":{
         "1":"5.1	Biotecnología y Farmacéutica // Biotecnología",
         "2":"5.2	Biotecnología y Farmacéutica // Farmacéutica",
         "3":"5.3	Biotecnología y Farmacéutica // Otra"
      }
   },
   "4":{
      "NOMBRE":"6.0 Construcción",
      "SUBSECTORES":{
         "1":"(OLD) Construcción // Contratación",
         "2":"(OLD) Construcción // Infraestructura",
         "3":"6.1	Construcción // Otra / No aplica"
      }
   },
   "5":{
      "NOMBRE":"12.0 Cuidado de la Salud",
      "SUBSECTORES":{
         "1":"(OLD) Cuidado de la Salud // Servicios de atención residencial",
         "2":"12.1 Cuidado de la Salud // Hospital",
         "3":"12.2 Cuidado de la Salud // Venta o Distribución de Insumos Médicos",
         "4":"12.3 Cuidado de la Salud // Especialidad",
         "5":"(OLD) Servicios de envejecimiento // Atención en el hogar",
         "6":"(OLD) Servicios de envejecimiento // Vivienda y cuidado para personas mayores",
         "7":"(OLD) Atención médica // Otros servicios especializados",
         "8":"12.4 Cuidado de la Salud // Servicios",
         "9":"12.5 Cuidado de la Salud // Otra",
      }
   },
   "6":{
      "NOMBRE":"7.0 Educación y Formación",
      "SUBSECTORES":{
         "1":"7.1 Educación y Formación // Otra / No aplica"
      }
   },
   "7":{
      "NOMBRE":"13.0 Hospitalidad",
      "SUBSECTORES":{
         "3":"13.1 Hospitalidad // Servicio de alimentos y bebidas",
         "2":"13.2 Hospitalidad // Hotel / Resort",
         "1":"13.3 Hospitalidad // Administración",
         "4":"13.4 Hospitalidad // Otra"
      }
   },
   "8":{
      "NOMBRE":"16.0 Manufactura y Producción",
      "SUBSECTORES":{
         "28":"16.1 Manufactura y Producción // Energía Alternativa",
         "1":"16.2 Manufactura y Producción // Automotriz",
         "15":"16.3 Manufactura y Producción // Metales Básicos y Productos metálicos",
         "14":"16.4 Manufactura y Producción // Materiales para la Construcción",
         "24":"16.5 Manufactura y Producción // Químicos",
         "3":"16.6 Manufactura y Producción // Coque, derivados del petróleo y combustible nuclear",
         "8":"16.7 Manufactura y Producción // Equipamiento eléctrico, electrónico y óptico",
         "6":"16.8 Manufactura y Producción // Electrónica",
         "7":"16.9 Manufactura y Producción // Energía",
         "5":"16.10 Manufactura y Producción // Distribución de Energía",
         "20":"16.11 Manufactura y Producción // Productos Alimenticios: Lácteos y productos avícolas",
         "21":"16.12 Manufactura y Producción // Productos Alimenticios: Tabaco",
         "19":"16.13 Manufactura y Producción // Productos Alimenticios: Bebidas",
         "18":"16.14 Manufactura y Producción // Productos Alimenticios: Otros",
         "16":"16.15 Manufactura y Producción // Muebles",
         "10":"16.16 Manufactura y Producción // Gasolina/Venta al por menor",
         "31":"16.17 Manufactura y Producción // Cuidado de la Salud",
         "17":"16.18 Manufactura y Producción // Cuero y productos de cuero",
         "13":"16.19 Manufactura y Producción // Maquinaria y equipo",
         "11":"16.20 Manufactura y Producción // Dispositivos médicos",
         "22":"16.21 Manufactura y Producción // Minerales no metálicos",
         "2":"16.22 Manufactura y Producción // Productos para el cuidado personal y del hogar",
         "23":"16.23 Manufactura y Producción // Pulpa, papel y derivados de papel",
         "4":"16.24 Manufactura y Producción // Productos de caucho y plástico",
         "25":"16.25 Manufactura y Producción // Seguridad",
         "26":"16.26 Manufactura y Producción // Textiles y productos textiles",
         "30":"16.27 Manufactura y Producción // Equipo de transporte",
         "29":"16.28 Manufactura y Producción // Abastecimiento y tratamiento de agua",
         "12":"16.29 Manufactura y Producción // Madera y derivados de la madera",
         "32":"16.30 Manufactura y Producción // Otra",
         "27":"(OLD) Manufactura y Producción // Bienes de consumo de rápido movimiento",
         "9":"(OLD) Manufactura y Producción // Asistencia sanitaria",
      }
   },
   "9":{
      "NOMBRE":"17.0 Medios de Comunicación",
      "SUBSECTORES":{
         "1":"17.1 Medios de Comunicación // Editoriales e imprentas",
         "4":"17.2 Medios de Comunicación // Televisión/Cine/Video",
         "2":"17.3 Medios de Comunicación // Radio",
         "3":"17.4 Medios de Comunicación // Servicios de Internet",
         "5":"17.5 Medios de Comunicación // Otra",
      }
   },
   "10":{
      "NOMBRE":"18.0 Minería y canteras",
      "SUBSECTORES":{
         "1":"18.1 Minas y Canteras // Otra / No aplica"
      }
   },
   "11":{
      "NOMBRE":"(OLD) Organizaciones sin fines de lucro y de caridad",
      "SUBSECTORES":{
         "1":"-"
      }
   },
   "12":{
      "NOMBRE":"21.0 Comercio Minorista",
      "SUBSECTORES":{
         "4":"21.1 Comercio Minorista // Ropa/Textiles/Calzado",
         "2":"21.2 Comercio Minorista // Computadores/Electrónica",
         "1":"21.3 Comercio Minorista // Alimentos/Almacén",
         "5":"21.4 Comercio Minorista // Comercio Electrónico",
         "3":"21.5 Comercio Minorista // Productos especializados",
         "6":"21.6 Comercio Minorista // Otra",
      }
   },
   "13":{
      "NOMBRE":"11.0 Servicios Financieros y Seguros",
      "SUBSECTORES":{
         "1":"11.1 Servicios Financieros y Seguros // Inversiones",
         "9":"11.2 Servicios Financieros y Seguros // Contabilidad",
         "8":"11.3 Servicios Financieros y Seguros // Servicios Bancarios/Crediticios",
         "5":"11.4 Servicios Financieros y Seguros // Seguros de la Salud",
         "7":"11.5 Servicios Financieros y Seguros // Seguros en General",
         "6":"11.6 Servicios Financieros y Seguros // Seguros de Vida",
         "3":"11.7 Servicios Financieros y Seguros // Seguros de Automóvil",
         "4":"11.8 Servicios Financieros y Seguros // Seguros de Hogar",
         "2":"11.9 Servicios Financieros y Seguros // Reaseguros",
         "10":"11.10 Servicios Financieros y Seguros // Otra",
      }
   },
   "14":{
     "NOMBRE":"14.0 Servicios Industriales",
     "SUBSECTORES":{
       "3":"14.1 Servicios Industriales // Reparación y Mantenimiento de Vehículos",
       "2":"14.2 Servicios Industriales // Diseño Industrial",
       "1":"14.3 Servicios Industriales // Residuos/Basura/Administración del Reciclaje",
       "4":"14.4 Servicios Industriales // Otra",
     }
   },
   "15":{
      "NOMBRE":"19.0 Servicios Profesionales",
      "SUBSECTORES":{
         "14":"19.1 Servicios Profesionales // Publicidad y Marketing",
         "2":"19.2 Servicios Profesionales // Arquitectura/Diseño",
         "5":"19.3 Servicios Profesionales // Consultoría – Administración",
         "7":"19.4 Servicios Profesionales // Consultoría en Ingeniería",
         "4":"19.5 Servicios Profesionales // Consultoría Ambiental",
         "8":"19.6 Servicios Profesionales // Consultoría en manufactura",
         "3":"19.7 Servicios Profesionales // Evaluación de Riesgos/Consultoría Actuarial",
         "11":"19.8 Servicios Profesionales // Asesoramiento Legal",
         "16":"19.9 Servicios Profesionales // Seguridad",
         "15":"19.10 Servicios Profesionales // Contratación de Personal",
         "6":"19.11 Servicios Profesionales // Soporte Telefónico/Centros de Ventas",
         "1":"19.12 Servicios Profesionales // Administración de Viajes",
         "19":"19.13 Servicios Profesionales // Otra",
         "12":"(OLD) Servicios profesionales // Outsourcing de procesos comerciales",
         "13":"(OLD) Servicios profesionales // Outsourcing de procesos de negocios / Call centers",
         "9":"(OLD) Servicios profesionales // Contabilidad, teneduría de libros y auditoría",
         "17":"(OLD) Servicios profesionales // Publicidad y marketing / Publicidad",
         "18":"(OLD) Servicios profesionales // Publicidad y marketing / Marketing directo",
         "10":"(OLD) Servicios profesionales // Educación y formación"
      }
   },
   "16":{
      "NOMBRE":"22.0 Servicios Sociales y Agencias Gubernamentales",
      "SUBSECTORES":{
         "3":"22.1 Servicios Sociales y Agencias Gubernamentales // Servicios de Negocio",
         "1":"22.2 Servicios Sociales y Agencias Gubernamentales // Cultura y Arte",
         "2":"22.3 Servicios Sociales y Agencias Gubernamentales // Educación",
         "6":"22.4 Servicios Sociales y Agencias Gubernamentales… Actividades de administración pública en general",
         "5":"22.5 Servicios Sociales y Agencias Gubernamentales // Vivienda",
         "4":"22.6 Servicios Sociales y Agencias Gubernamentales // Salud Humana y Trabajo Social",
         "7":"22.7 Servicios Sociales y Agencias Gubernamentales // Atención Residencial",
         "8":"22.8 Servicios Sociales y Agencias Gubernamentales // Otra",
      }
   },
   "17":{
      "NOMBRE":"15z.0 Tecnologías de la Información",
      "SUBSECTORES":{
         "3":"15.1 Tecnologías de la Información // Hardware",
         "4":"15.2 Tecnologías de la Información // Proveedor de Servicios de Internet",
         "5":"15.3 Tecnologías de la Información // Software",
         "6":"15.4 Tecnologías de la Información // Servicios de Internet",
         "1":"15.5 Tecnologías de la Información // Consultoría de TI",
         "2":"15.6 Tecnologías de la Información // Almacenamiento/Administración de Datos",
         "7":"15.7 Tecnologías de la Información // Otra",
      }
   },
   "18":{
      "NOMBRE":"24.0 Transporte",
      "SUBSECTORES":{
         "2":"24.1 Transporte // Aerolínea/Aviación comercial",
         "1":"24.2 Transporte // Transporte de paquetería",
         "3":"24.3 Transporte // Transporte terrestre y marítimo de pasajeros",
         "4":"24.4 Transporte // Transporte y Almacenamiento",
         "5":"24.5 Transporte // Otra",
      }
   },
   "19":{
      "NOMBRE":"23.0 Telecomunicaciones",
      "SUBSECTORES":{
         "1":"23.1 Telecomunicaciones // Otra / No aplica"
      }
   },
   "20":{
      "NOMBRE":"8.0 Electrónica",
      "SUBSECTORES":{
         "1":"8.1 Electrónica // Otra / No aplica"
      }
   },
   "21":{
      "NOMBRE":"9.0 Ingeniería",
      "SUBSECTORES":{
         "1":"9.1 Ingeniería // Otra / No aplica"
      }
   },
   "22":{
      "NOMBRE":"10.0 Entretenimiento",
      "SUBSECTORES":{
         "3":"10.1 Entretenimiento // Artes escénicas y deportes para espectadores",
         "2":"10.2 Entretenimiento // Museos",
         "1":"10.3 Entretenimiento // Diversión y juegos de azar",
         "4":"10.4 Entretenimiento // Otra",
      }
   },
   "23":{
      "NOMBRE":"20.0 Inmuebles",
      "SUBSECTORES":{
         "1":"20.1 Inmuebles // Vivienda",
         "2":"20.2 Inmuebles // Administración de la propiedad",
         "3":"20.3 Inmuebles // Otra",
      }
   },
   "24":{
      "NOMBRE":"25.0 Otra",
      "SUBSECTORES":{
         "1":"25.1 Otra / No aplica"
      }
   },
   "25": {
     "NOMBRE":"3.0 Servicios para el Adulto Mayor",
     "SUBSECTORES": {
       "1":"3.1 Servicios para el Adulto Mayor // Vivienda y cuidado del Adulto Mayor",
       "2":"3.2 Servicios para el Adulto Mayor // Atención domiciliaria",
       "3":"3.3 Servicios para el Adulto Mayor //Otra",
     }
   }
}

export const ranking = {
  '1': {
    'NOMBRE': 'Si',
    'TIPO': {
      '1': 'Menos de 50',
      '2': '50 a 500 No multinacionales',
      '3': '50 a 500 Multinacionales',
      '4': 'Grandes (500 a 4999)',
      '5': '5000 o más'
      // '6': 'Sector público',
      // '7': 'No participa en la clasificación'
    }
  },
  '2': {
    'NOMBRE': 'No',
    'TIPO': {
      '1': 'Menos de 50',
      '2': '50 a 500 No multinacionales',
      '3': '50 a 500 Multinacionales',
      '4': 'Grandes (500 a 4999)',
      '5': '5000 o más'
    }
  },
  'Nacional': 'Nacional',
  'Multinacional': 'Multinacional'
}

export const productos = {
  '1': 'Certificar',
  '2': 'Medir',
  '3': 'NOM-035',
  '4': 'Pulse Check',
  '5': 'Documentador NOM-035',
  '6': 'Focus Area',
  '7': 'Gestor de archivos',
  '8': 'Culture Audit',
  '9': 'Culture Audit 5.0',
  '10': 'Culture Audit Training',
  '11': 'Medir mejorado',
  '12': 'Medir + MST',
  '13': 'Medir por áreas',
  '14': 'Medir por líderes',
  '15': 'Medir por dimensiones',
  '16': 'Medir para certificar',
  '17': 'Resultados',
  '18': '4All',
  '19': 'NOM-035 Better',
  '20': 'Certificar v2.0',
  '21': 'Resultados globales',
  '22': 'Resultados sencillos prácticas 4ALL',
  '23': 'Resultados completos',
  '24': 'Paquete PLATA',
  '25': 'Paquete ORO',
  '26': 'Paquete PLATINO',
  '27': 'Izzi',
  '30': 'Culture Audit Costa Rica',
  '31': 'Culture Audit GoFlow',
  '32': 'Culture Audit 5.0 Panamá',
  '33': 'Culture Audit 5.0 Strategic Partners',
  '34': 'Results 5.0 Versión 3.1',
  '35': 'Results 5.0 Versión 3.2',
  '36': 'Results 5.0 Versión 3.3',
  '37':'Culture Audit SP',
  '38':' Action Plan',
  '39':'NOM-035 Plata',
  '40': 'Certificar v3.0',
  '41': 'Medir v3.0',
  '42': 'Pulse Check v3.0',
  '43': 'Focus Area v3.0',
  '48': 'SP 2021',
  '49': 'Culture Audit GoFlow 2-2021',
  'CULTUREGOEXPRESS':'Cultural Go Express',
  '53':'Líder GO',
  '54':'Action GO',
  '56':'AMCO',
  '57':'Trabajo digno',
  '58':'Primer Empleo',
  'ENCUESTA':'Certificaciones adicionales',
  '60':'Certificar (importar emprising)',
  '61':'Culture Brief',
  '62':'Culture Brief + Culture Audit',
  '63': 'NOM-035 v3.0',
  '64':'SP 2022',
  '65':'Culture Audit GoFlow 2 2022',
  '66':'Culture Audit Estandar 1',
  '67':'Culture Audit® CA&C',
  '69':'Certificar plata',
  '70':'Resultados GoFlow',
  '71':'Culture Brief (certificar) 2022',
  '72':'Culture Audit (certificar, rkg.) 2022',
  '73':'Culture Audit (certificar, rkg. y adic.) 2022',
  '68':'Swift',
  '76':'Culture Audit (certificar,rkg. y adic.) 2024',
  '77':'Culture Brief (certificar) 2024',
  '78':'Culture Audit (certificar y ranking) 2024',
}

export const productosTurquia = {
  '1': 'Certificar',
  '2': 'Medir',
  '3': 'NOM-035',
  '4': 'Pulse Check',
  '5': 'Documentador NOM-035',
  '6': 'Focus Area',
  '7': 'Gestor de archivos',
  '8': 'Culture Audit',
  '9': 'Culture Brief ve Culture Audit 5.0',
  '10': 'Culture Audit Training',
  '11': 'Medir mejorado',
  '12': 'Medir + MST',
  '13': 'Medir por áreas',
  '14': 'Medir por líderes',
  '15': 'Medir por dimensiones',
  '16': 'Medir para certificar',
  '17': 'Resultados',
  '18': '4All',
  '19': 'NOM-035 Better',
  '20': 'Certificar v2.0',
  '21': 'Resultados globales',
  '22': 'Resultados sencillos prácticas 4ALL',
  '23': 'Resultados completos',
  '24': 'Paquete PLATA',
  '25': 'Paquete ORO',
  '26': 'Paquete PLATINO',
  '27': 'Izzi',
  '28': 'Culture Brief 5.0',
  '29': 'Culture audit 5.0',
  '34': 'Resultados 5.0 Versión 3.1',
  '35': 'Resultados 5.0 Versión 3.2',
  '36': 'Resultados 5.0 Versión 3.3',
  '40': 'Certificar v3.0',
  '41': 'Medir v3.0',
  '42': 'Pulse Check v3.0',
  '43': 'Focus Area v3.0',
  '60':'Certificar (importar emprising)',
  '54':'Action GO',
  '74':'Özel Liste',
}

export const categorias = {
  'Certify': 'Productos Certificar',
  'Measure': 'Productos Medir',
  'Norm 35': 'Productos NOM-035',
  'Pulse Check': 'Productos Pulse Check',
  'Focus Area': 'Productos Focus Area',
  'Drive': 'Gestor de archivos',
  'Culture Audit': 'Productos Culture Audit',
  'Resultados': 'Productos de resultados',
  'Resultados 4 ALL': 'Productos 4All',
  'Resultados 5.0': 'Productos resultados 5.0',
  'Culture Audit Action Plan':'Action plan',
  'Leader GO':'Líder GO',
  'Action GO':'Action GO',
  'Certify Amco':'Certificaciones adicionales',
  'Culture Audit ICCA':'Productos ICCA',
  'AMCO': {
    'Measure': 'Productos ICI',
    'Culture Audit': 'Productos ICCA',
  },
  'Resultados V2 HK':'Certificar (importar emprising)',
  'Swift':'Swift',
}

export const niveles = {
  '1': 'Empresa',
  '2': 'Administrador',
  '3': 'ITBM',
  '4': 'Resultados',
  '5': 'Resultados segmentados',
  '8': 'Producto Culture Audit',
  '9': 'Resultados 5.0',
  '10':'Compañia RH',
  '11': 'Izzi',
  '12': 'ActionGo',
  '13': 'Resultados segmentados y ActionGo',
  '14': 'ActionGo Líder',
  '15': 'Usuario ActionGo Líder',
  '17': 'Mayorista Swift',
  '18': 'Perfil de la empresa en la web',
  '19': 'Resultados 2.0',
}

export const regiones = {
  '1': 'Caribe',
  '2': 'Centro America',
  '3': 'Centroamerica y Caribe',
  '4': 'Region Bajio',
  '5': 'Region Centro',
  '6': 'Region Centro Occidente',
  '7': 'Region Centro Sur',
  '8': 'Region Noreste',
  '9': 'Region Noroeste',
  '10': 'Region Sureste',
  '11': 'Hong Kong',
  '12': 'Taiwán',
  '13': 'China continental',
  '14': 'Gran China',
  '15': 'Turquia',
}

export const plantillas = {
  '5d826095d06d596a84de6315': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5dcb61e940fb582bc44adf49': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5dcc946633e1ff000870107e': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5dcdd9fd33e1ff1aacf6f04f': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5ddc3fa4f323d727d09870ad': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5de58de640fb582e0c18d730': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5de69aa4a943da3efc4d0fa6': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PULSECHECK'
  },

  '5de9498fa943da3efc4d0fa8': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5df820df65e4986b14d1f71c': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },

  '5dfc26cec8800d5188a18875': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e166105d06d595eb04dca00': {
    'NOMBRE':'Focus_Estandar'
  },

  '5e1754a5f323d72aac6d8726': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e17930b65e4983a3016a4ed': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e2100c6f323d721045812c5': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e21042ff323d721045812c6': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e210575f323d721045812c7': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e2b6dbdc8800d52f45fc248': {
    'NOMBRE':'TEMPLATE 10 PREGUNTAS ESP'
  },

  '5e2f72c8c8800d3398c463a4': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e3c59b5b473cb6d3e40f902': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e697232b473cb6d3e84d87d': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5ec8450db473cb6d3ec9d153': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_US_MEDIR1'
  },

  '5ec84527b473cb6d3ec9dcdb': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_MX_MEDIR1'
  },

  '5e6972f3b473cb6d3e84e1e0': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR1'
  },

  '5e697302b473cb6d3e84e2a3': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR2'
  },

  '5e697311b473cb6d3e84e364': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR3'
  },

  '5e697329b473cb6d3e84e490': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR4'
  },

  '5e69734fb473cb6d3e84e656': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR5'
  },

  '5f074b90b473cb6d3eb363d1': {
    'NOMBRE':'ESP_MEDIR_CREDIBILIDAD'
  },

  '5e697367b473cb6d3e84e791': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR6'
  },

  '5e738efbb473cb6d3e8c3915': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },

  '5e86487eb473cb6d3e09cc42': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5e864896b473cb6d3e09cde1': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },
  '5ebb34dab473cb6d3edd2d32': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_US'
  },

  '5ebc06d1b473cb6d3ef68147': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MX'
  },

  '5f2d7cdfb473cb6d3edd2c48': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PT'
  },

//PLANTILLAS DE CERTIFICAR 2.0
  '5e960018b473cb6d3ec5f935': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5e96007cb473cb6d3ec60098': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5e9600a6b473cb6d3ec603c7': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5e9600f0b473cb6d3ec6095a': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5e960116b473cb6d3ec60c2f': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5e96039fb473cb6d3ec64310': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e9603d7b473cb6d3ec6485e': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e9604f7b473cb6d3ec66540': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e960525b473cb6d3ec66a3f': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e960549b473cb6d3ec66e30': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e96056ab473cb6d3ec671f1': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e9605b5b473cb6d3ec67a55': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e9605e0b473cb6d3ec67f3c': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e96060fb473cb6d3ec684d8': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },

  '5f109a39b473cb6d3ea95e69': {
    'NOMBRE':'ING_VI_ESTANDAR'
  },

  '5f0f390cb473cb6d3ea20f9c': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN_V2'
  },

  '5f2adf75b473cb6d3eb782e2': {
    'NOMBRE':'REACTIVOS-BRASIL-PT'
  },

  '5f0773b196bd3c7a9e469a8b': {
    'NOMBRE':'TR_ESTANDAR_+COVID'
  },

  '5f0773ea96bd3c7a9e469e56': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER_+COVID'
  },

  '5f07740e96bd3c7a9e46a0f1': {
    'NOMBRE':'TR TI + EVP_+COVID'
  },

  '5f40081eb473cb6d3ec99926': {
    'NOMBRE':'TR TI + GPTW LEADER_5_+ COVID'
  },
  '5f5fbb3496bd3c7a9eac2768': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_US'
  },

  '5f5fb74496bd3c7a9eab015a': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_MX'
  },

  '5f68c206b473cb6d3ebe8473': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_US'
  },

  '5f68c222b473cb6d3ebe94b3': {
    'NOMBRE':'04_ESP_ING_ESTANDAR_MX'
  },
  '5f84a2fab473cb6d3e017c0d': {
    'NOMBRE':'ESP_ESTANDAR_IDIOMAS'
  },
  '5f733fcab473cb6d3e19d56c': {
    'NOMBRE':'04_ESP_Gobierno_MX'
  },
  // pendiente TK
  '5e14fc2cf323d72aac6d8722': {
    'NOMBRE':' '
  },
  // pendiente TK
  '5e14fcc4f323d72aac6d8723': {
    'NOMBRE':' '
  },
  // pendiente MX
  '5d71b21db11f333a30de813e': {
    'NOMBRE':' '
  },

  '5f99fa14b473cb6d3e2d4012': {
    'NOMBRE':'TR_EN_DE_PT_ZH1_TI_+_EVP'
  },

  '5f9b4550b473cb6d3e51c24d': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5fcebf59c1057065a70fe712':{
    'NOMBRE':'TR_ESTANDAR_+COVID v2'
  },
  '6046a10e7308ab51607f95b5':{
    'NOMBRE':''
  }

}

export const paises = {
  '1': 'México',
  '2': 'Costa Rica',
  '3': 'Panamá'
}

export const answer = {
  '1': 'Cultural Go Survey',
  '2': 'Kiosko',
  '3': 'No Responde / Líder Extranjero',
  '4': 'Papel',
  '5': 'No aplica',
  '6': 'Importado'
}

export const nameTHConsEncuesta = {
  'TH_SUR_TOK':'Survey Token',
  'TH_NAM_EMP': 'Nombre de la empresa',
  'TH_NAM_EMP_PUB': 'Nombre de publicación',
  'TH_PA_EMP': 'Pais',
  'TH_CER_DAT': 'Fecha del certificado',
  'TH_SEC': 'Sector',
  'TH_TI_ENC': 'Tipo encuesta',
  'TH_SUR_STA': 'Inicio encuesta',
  'TH_SUR_EN': 'Fin encuesta',
  'TH_ID_ACON': 'ID Acount',
  'TH_ID_OPOR': 'ID Oportunity',
  'TH_ANO_RA': 'Año Ranking',
  'TH_COMPA':'Compañerismo',
  'TH_CRED':'Credibilidad',
  'TH_CATE_TAN':'Categoría ranking',
  'TH_CONFI':'Confianza',
  'TH_ES_MULT':'Es Multinacional?',
  'TH_GR_MUL_PER':'Grupo multinacional al que pertenece',
  'TH_GEST':'Gestalt',
  'TH_IMPA':'Imparcialidad',
  'TH_INN_TOD':'Innovación por Todos',
  'TH_LID_EFE':'Liderazgo Efectivo',
  'TH_LID_MOV':'Liderazgo en Movimiento' ,
  'TH_MAX_CAS':'Maximizar CAST(Potencial Humano)',
  'TH_ORG':'Orgullo',
  'TH_PA_LEAFF':'Pais',
  'TH_PR_ARE':'Promedio area',
  'TH_PR_EMP':'Promedio empresa',
  'TH_PR_TI':' Promedio TI',
  'TH_REG':'Región',
  'TH_RES':'Respeto',
  'TH_PRO_CUE':'Propietario cuenta',
  'TH_TOT_CA_AVG':'Total CA (AVG)',
  'TH_TOT_CA_SU':'Total CA (SUMA)',
  'TH_VAL':'Valores',
  'TH_NIV_CONF':'¿Cuál es tu nivel de confianza en las capacidades de los directores de tu empresa? APLICO (SI / NO):',
  'TH_EN_ULT_12':'En los últimos 12 meses, ¿cuántas oportunidades has tenido para desarrollar, innovar o crear nuevas o mejores formas de:',
  'TH_#_RES_EST':'# RESPUESTAS ESTUDIOS',
  'TH_CAR_HOMO':'Cargo o función homologado US APLICO (SI / NO):',
  'TH_ED_US_AP':'Edad US APLICO',
  'TH_GEN_US_AP':'Generación US APLICO (SI / NO):',
  'TH_GE_APL':'Género APLICO (SI / NO):',
  'TH_SI_AP':'Situación laboral US APLICO (SI / NO):',
  'TH_HC':'# HC',

}
